import fetch from "@lib/fetch";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";

import { cacheKey } from "./constants";
import type { ImageDataResponse, PostImageDimensionsProps } from "./types";

export const postImageData = reactQueryMutationAdapter(
  cacheKey,
  async ({ appGroupId, imageData }: { appGroupId: string; imageData: PostImageDimensionsProps }) => {
    return await fetch<ImageDataResponse>(`/engagement/${appGroupId}/library_image`, "POST", imageData);
  }
);
